export default function Gouvernance() {
  const elements = [
    {
      icon: 'ri-building-line',
      titre: 'Entreprise canadienne',
      description: 'OTOROBOTS CANADA INC. est une entreprise légalement constituée et opérationnelle au Canada, respectant l\'ensemble des normes et réglementations en vigueur.'
    },
    {
      icon: 'ri-organization-chart',
      titre: 'Structure mère',
      description: 'Nous agissons comme cadre de gouvernance pour différentes initiatives distinctes : applications, formations, outils numériques et plateformes éducatives.'
    },
    {
      icon: 'ri-shield-check-line',
      titre: 'Gouvernance responsable',
      description: 'Chaque initiative possède sa propre identité, son propre site et son propre parcours, tout en s\'inscrivant dans notre vision commune.'
    },
    {
      icon: 'ri-bank-card-line',
      titre: 'Infrastructure de paiement',
      description: 'Nous utilisons Stripe comme plateforme de paiement sécurisée pour les initiatives distinctes et autonomes qui en ont besoin.'
    }
  ];

  return (
    <section id="gouvernance" className="bg-white py-16 sm:py-24 lg:py-32 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extralight text-gray-900 mb-4 sm:mb-6">
            Cadre & Gouvernance
          </h2>
          <p className="text-base sm:text-lg text-gray-600 font-light max-w-3xl mx-auto px-4">
            OTOROBOTS CANADA INC. est une structure mère et un cadre de référence institutionnelle, pas un site de projets ou de vente.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {elements.map((element, index) => (
            <div
              key={index}
              className="bg-[#FAF8F5] p-6 sm:p-8 lg:p-10 rounded-lg hover:shadow-md transition-shadow"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center mb-4 sm:mb-6">
                <i className={`${element.icon} text-3xl sm:text-4xl text-gray-900`}></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-3 sm:mb-4">{element.titre}</h3>
              <p className="text-sm sm:text-base font-light text-gray-700 leading-relaxed">
                {element.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-[#0A0A0A] rounded-2xl p-8 sm:p-10 lg:p-12 text-center">
          <h3 className="text-2xl sm:text-3xl font-light text-white mb-3 sm:mb-4">
            Des initiatives distinctes, une vision commune
          </h3>
          <p className="text-sm sm:text-base text-white/80 font-light max-w-2xl mx-auto leading-relaxed">
            Chaque projet soutenu par OTOROBOTS CANADA INC. possède sa propre marque, son propre site web et son propre parcours utilisateur. Notre rôle est d'assurer la cohérence stratégique et éthique de l'ensemble.
          </p>
        </div>
      </div>
    </section>
  );
}
